import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { match } from 'ts-pattern'
import { useMemo } from 'use-memo-one'

import { Tooltip } from '@blade/ui-kit'
import {
  BundlerIcon,
  InsiderIcon,
  LeafIcon,
  PumpFunMayhemPillLogo,
  SniperIcon,
} from '@root/shared/ui-kit'

import type { Maker } from '../model'

type MakerTagIconProps = {
  tag: Maker.MakerTag
  size: number
}

export const MakerTagIcon: React.FC<MakerTagIconProps> = ({ tag, size }) => {
  const { t } = useTranslation()
  const Icon = ICON_MAP[tag]

  const tooltip = useMemo(
    () =>
      match(tag)
        .with('bundler', () => t('maker.tag.bundler.tooltip'))
        .with('fresh', () => t('maker.tag.fresh.tooltip'))
        .with('insider', () => t('maker.tag.insider.tooltip'))
        .with('sniper', () => t('maker.tag.sniper.tooltip'))
        .with('mayhem', () => 'MAYHEM Vault')
        .exhaustive(),
    [tag, t],
  )

  return (
    <Tooltip content={tooltip}>
      <Icon size={size} />
    </Tooltip>
  )
}

const FreshIcon = styled(LeafIcon).attrs({
  style: {
    color: 'var(--up-9)',
  },
})``

const InsiderIconStyled = styled(InsiderIcon).attrs({
  style: {
    color: 'var(--down-9)',
  },
})``

const BundlerIconStyled = styled(BundlerIcon).attrs({
  style: {
    color: 'var(--cyan-9)',
  },
})``

const SniperIconStyled = styled(SniperIcon).attrs({
  style: {
    color: 'var(--amber-9)',
  },
})``

const MayhemIcon = ({ size }: { size: number }) => {
  return <PumpFunMayhemPillLogo size={size - 2} />
}

const ICON_MAP: Record<Maker.MakerTag, React.FC<{ size: number }>> = {
  insider: InsiderIconStyled,
  bundler: BundlerIconStyled,
  sniper: SniperIconStyled,
  fresh: FreshIcon,
  mayhem: MayhemIcon,
}
